var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.418 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.953 1.141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.134,304c0,14.45-8.534,21.487-22.834,21.487-14.374,0-22.759-6.961-22.759-21.487V270.758H306.3V304c0,5.841,1.5,11.606,11,11.606,8.384,0,11.081-3.668,11.081-11.606V270.758h11.752Z",
    transform: "translate(-294.542 -270.758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.565,270.757h37.576v9.883H363.318v11.454h25.9v9.134h-25.9v13.1h25.921v9.881H351.565Z",
    transform: "translate(-247.56 -269.617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.46,270.706h11.752v43.572h26.054v9.882H400.46Z",
    transform: "translate(-248.392 -269.616)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.592 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.1,321.3h18.118c9.432,0,15.347-4.192,15.347-12.129,0-9.134-8.312-11.38-15.347-11.38H452.1Zm0-26.353h18.118c8.907,0,13.55-4.492,13.55-11.005,0-7.71-6.44-10.406-13.55-10.406H452.1Zm-3.3-24.256h21.413c12.725,0,16.843,6.961,16.843,13.85a11.431,11.431,0,0,1-10.406,11.378l.15.151c1.421-.225,12.053,2.321,12.053,13.1,0,9.733-7.486,14.974-18.64,14.974H448.808Z",
    transform: "translate(-448.808 -269.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333,322.752c13.924,0,22.086-11.454,22.086-25.154s-8.162-25.156-22.086-25.156c-14,0-22.16,11.456-22.16,25.156s8.161,25.154,22.16,25.154m0,2.845c-16.019,0-25.453-12.352-25.453-28s9.434-28,25.453-28c15.946,0,25.38,12.353,25.38,28s-9.435,28-25.38,28",
    transform: "translate(-449.61 -269.597)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M551.536,270.74h3.819l16.919,23.507,17.294-23.507h3.743l-18.865,25.978,19.914,27.476H590.39l-18.117-25.005-18.193,25.005h-3.893l20.065-27.476Z",
    transform: "translate(-250.942 -269.617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.758,270.771h37.576v9.882H257.511v11.455h25.9v9.134h-25.9v22.984H245.758Z",
    transform: "translate(-245.758 -269.617)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64fc2a772325b1f2e72ea1e86fad9d46.svg";
export { ForwardRef as ReactComponent };